<template>
   <div class="page-header">
        <div class="header-left">
            <el-tabs v-model="activeHeaderTabName" @tab-click="handleHeaderTabClick"> 
                <el-tab-pane v-for="(item, index) in tabs" :key="index" :label="item.label" :name="item.name"></el-tab-pane>
            </el-tabs>
            <slot name="left"></slot>
        </div>
        <div class="header-right"><slot name="right"></slot></div>
    </div>
</template>

<script>
export default {
    props: {
        // activeHeaderTabName: {
        //     type: String,
        //     default: '1'
        // },
        tabs: {
            type: Array,
            default: new Array()
        }
    },
    data() {
        const tabs = this.tabs
        return {
            activeHeaderTabName: tabs[0].name
        }
    },
    methods: {
        handleHeaderTabClick() {
            this.$emit('handleHeaderTabClick', this.activeHeaderTabName)
        }
    }
}
</script>

<style lang="less" scoped>
    .page-header {
        background: white;
        height: 58px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 12px;
        padding-right: 40px;
        border-bottom: 1px solid #F7F8FA;
        .header-left {
            height: 100%;
            display: flex;
            align-items: center;
        }
        .header-right {
            height: 100%;
            display: flex;
            align-items: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/zzcbpmDashboard/common/page-header.vue